import { Node } from './node';

export interface DropInfo {
    targetId: string;
    action?: DropActionType;
}

export enum DropActionType {
    BEFORE = 'before',
    BEFOREILEGAL = 'beforeilegal',
    AFTER = 'after',
    AFTERILEGAL = 'afterilegal',
    INSIDE = 'inside',
    INSIDE_ILEGAL = 'insideilegal',
}

export enum SiblingPosition {
    BEFORE,
    AFTER,
}

export interface DropEndEvent {
    draggedItemId: string | number;
    parentItemId: string | number;
    newParentId: string | number;
    newList: any[];
    draggedItem: Node<any>;
    newTree: any;
}
